import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Spinner, Text, makeStyles, tokens } from '@fluentui/react-components';
import { useTeamsContext } from './teams/useTeamsContext';
import { useAuth } from './auth/useAuth';
import PipeCommercial from './pages/PipeCommercial';
import MissionsActives from './pages/MissionsActives';
import EnvoiBoond from './pages/EnvoiBoond';
import NotMapped from './pages/NotMapped';

const useStyles = makeStyles({
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    gap: tokens.spacingVerticalM,
  },
});

export default function App() {
  const styles = useStyles();
  const { initialized: teamsInit } = useTeamsContext();
  const { user, loading: authLoading, error: authError } = useAuth();

  if (!teamsInit || authLoading) {
    return (
      <div className={styles.loading}>
        <Spinner size="medium" label="Chargement..." />
      </div>
    );
  }

  if (authError) {
    return (
      <div className={styles.loading}>
        <Text size={400} weight="semibold">Erreur d'authentification</Text>
        <Text size={300}>{authError}</Text>
      </div>
    );
  }

  if (user && !user.boondUserId) {
    return <NotMapped user={user} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/tabs/pipe-commercial" element={<PipeCommercial />} />
        <Route path="/tabs/missions-actives" element={<MissionsActives />} />
        <Route path="/task/envoyer-vers-boond" element={<EnvoiBoond />} />
        <Route path="*" element={<Navigate to="/tabs/pipe-commercial" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
